import { getDefaultStatisticItem, getTeamLabelByNumber } from '../../utils/utils'

const lastTempBeforeUpdates = [
  {
    updatedProperty: '',
    team: 0,
    gamePeriod: 1,
    lastMaxPointSeries: 0
  }
]

const lastPointTeams = []

export default {
  statisticScheme: {
    'SCORE': getDefaultStatisticItem('trader.number.of.points.won'),
    'SERVE_WINNER': getDefaultStatisticItem('trader.number.of.winning.draws'),
    'SCORE_IN_ROW': getDefaultStatisticItem('trader.badminton.score.in.row')
  },
  statisticEvents: {},
  statisticOrder: [
    'SCORE',
    'SERVE_WINNER',
    'SCORE_IN_ROW'
  ],
  statisticFunction (event) {
    if (['SERVE_WINNER', 'POINT', 'CANCEL'].includes(event.EventCode)) {
      updateStatistic.call(this, event)
    }
  }
}

function updateStatistic (event) {
  if (event.EventCode === 'CANCEL') {
    const { RelatedEventNumber } = event
    const { getEventCache } = this
    const relatedEvent = getEventCache[RelatedEventNumber]
    const { EventCode } = relatedEvent

    if (['SERVE_WINNER', 'POINT'].includes(EventCode)) {
      goToPrevStatisticSnapshot.call(this)
    }

    return
  }

  const { TeamNumber, GamePeriod } = event
  const currentTeamLabel = getTeamLabelByNumber(TeamNumber)

  if (event.EventCode === 'POINT') {
    lastPointTeams.push(currentTeamLabel)
  }
  const maxPointSeries = calculateMaxPointSeries(currentTeamLabel)

  if (event.EventCode === 'POINT') {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SCORE',
      period: GamePeriod,
      team: currentTeamLabel,
      type: 'increment'
    })

    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SCORE_IN_ROW',
      period: GamePeriod,
      team: currentTeamLabel,
      value: maxPointSeries
    })
  }

  if (event.EventCode === 'SERVE_WINNER') {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SERVE_WINNER',
      period: GamePeriod,
      team: currentTeamLabel,
      type: 'increment'
    })
  }

  const propertyNameObj = {
    'SERVE_WINNER': 'SERVE_WINNER',
    'POINT': 'SCORE'
  }

  lastTempBeforeUpdates.push(
    {
      updatedProperty: propertyNameObj[event.EventCode],
      team: currentTeamLabel,
      gamePeriod: GamePeriod,
      lastMaxPointSeries: maxPointSeries
    })
}

function goToPrevStatisticSnapshot () {
  const lastTemp = lastTempBeforeUpdates.pop()

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: lastTemp.updatedProperty,
    period: lastTemp.gamePeriod,
    team: lastTemp.team,
    type: 'decrement'
  })

  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'SCORE_IN_ROW',
    period: lastTemp.gamePeriod,
    team: lastTemp.team,
    value: calculateMaxPointSeries(lastTemp.team)
  })
}

function calculateMaxPointSeries (team) {
  if (lastPointTeams.length === 0) return 0

  let seriesLength = 0
  let maxSeriesLength = 0

  for (let i = 0; i < lastPointTeams.length; i++) {
    if (lastPointTeams[i] === team) {
      seriesLength += 1
      if (seriesLength > maxSeriesLength) {
        maxSeriesLength = seriesLength
      }
    } else {
      seriesLength = 0
    }
  }
  return maxSeriesLength
}
